import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import ReportsStatsWrapper from "@/components/reports/reports-stats-wrapper";
import ReportsTable from "@/components/reports/reports-table";

const reportsSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/reports/")({
  validateSearch: reportsSearchSchema,
  component: ReportsPage,
});

function ReportsPage() {
  const searchParams = Route.useSearch();

  return (
    <div className="flex-1 flex flex-col min-h-0">
      <div className="flex-1 min-h-0 ">
        <ReportsTable
          currentPage={searchParams.page}
          pageSize={10}
          basePath="/reports"
          searchParams={searchParams}
        />
      </div>
    </div>
  );
}
